module.exports = __webpack_public_path__ + "img/riskIconTall.cb8a1a84.png";